var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('logged-in-header'),_c('configs-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }